import { BankAccount } from "./bank-account";
import { Identifier } from "./identifier";

export class Party {
	Nr:string;
	Name:string;
	Street:string;
	StreetNumber:string;
	Box:string;
	Zipcode:string;
	City:string;
	CountryCode:string;
	IBAN:string;
	BIC:string;
	Mobile:string;
	Phone:string;
	Fax:string;
	Email:string;
	Website:string;
	Contact:string;
	VATNumber:string;
	PartyType:string;
	VATLiable:boolean;
	AccountantCode:number;
	Language:string;
	VentilatinoCode:string;
	BankAccounts:BankAccount[] = []
	DefaultPaymentMethodTC:string;
	Identifiers:Identifier[] = [];
	EndpointID:string;


	public constructor(data:any){
		this.Nr = data.Nr || "";
		this.Name = data.Name || "";
		this.Street = data.Street || "";
		this.StreetNumber = data.StreetNumber || "";
		this.Box = data.Box || "";
		this.Zipcode = data.Zipcode || "";
		this.City = data.City || "";
		this.CountryCode = data.CountryCode || "";
		this.IBAN = data.IBAN || "";
		this.BIC = data.BIC || "";
		this.Mobile = data.Mobile || "";
		this.Phone = data.Phone || "";
		this.Fax = data.Fax || "";
		this.Email = data.Email || "";
		this.Website = data.Website || "";
		this.Contact = data.Contact || "";
		this.VATNumber = data.VATNumber || "";
		this.PartyType = data.PartyType || "";
		this.VATLiable = data.VATLiable || false;
		this.AccountantCode = data.AccountantCode || 0;
		this.Language = data.Language || "";
		this.VentilatinoCode = data.VentilatinoCode || "";
		this.BankAccounts = ((data.BankAccounts || []) as any[]).map(b=>new BankAccount(b));
		this.DefaultPaymentMethodTC = data.DefaultPaymentMethodTC || "";
		this.Identifiers = ((data.Identifiers || []) as any[]).map(i=>new Identifier(i));
		this.EndpointID = data.EndpointID;
	}
}